"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContinueOnWebStatusText = exports.delayedTextTimeoutMs = void 0;
const React = require("react");
const Header_1 = require("../Header");
// After this delay, the initial status text is swapped for a "taking longer than
// usual" message so the user isn't staring at the same copy indefinitely.
exports.delayedTextTimeoutMs = 5000;
/**
 * Title + subtitle shown - in place of the normal Header - while ModernViewContainer waits
 * for the AuthSsoDetectorService result after the user clicks "Continue on this browser",
 * before routing to LIME or RWC. Reuses Header so the typography exactly matches the
 * buttons view it temporarily replaces.
 */
class ContinueOnWebStatusText extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = { showDelayedText: false };
    }
    componentDidMount() {
        this.delayedTextTimeoutId = window.setTimeout(() => {
            this.setState({ showDelayedText: true });
        }, exports.delayedTextTimeoutMs);
    }
    componentWillUnmount() {
        window.clearTimeout(this.delayedTextTimeoutId);
    }
    render() {
        return (React.createElement(Header_1.Header, { title: "txt_continue_on_web_title", text: this.state.showDelayedText
                ? "txt_continue_on_web_checking_status_delayed"
                : "txt_continue_on_web_checking_status", isUIv3: true }));
    }
}
exports.ContinueOnWebStatusText = ContinueOnWebStatusText;
